import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      <p>© 2025 Grade Your Day. All rights reserved.</p>
    </footer>
  );
}